<template>
  <div>

  <van-field style="margin-top:10px" disabled v-model="st" label="Servis Tipi"/>

   <van-field style="margin-top:10px" disabled clickable name="picker" :value="value" label="Nedeni(*)" @click="showPicker = true"
  />

  <van-field style="margin-top:10px"  v-model="mesaj" label="Görüş(*)" type="textarea" maxlength="400" show-word-limit
/>

<van-grid :column-num="3">
  <van-grid-item>
  <van-button @click="tamamla('0','0','Başarılı olarak ')" style="height:80px" block  type="primary">Başarılı</van-button>
  </van-grid-item>
  <van-grid-item>
    <van-button @click="tamamla('1','0','iptal olarak ')" style="height:80px" block type="danger">İptal Edildi</van-button>
  </van-grid-item>
  <van-grid-item v-if="stid===2">
    <van-button @click="tamamla('0','1','Değişim olarak ')" style="height:80px" block type="warning">DEĞİŞİM</van-button>
  </van-grid-item>  
</van-grid>

<van-popup v-model="showPicker" position="bottom">
  <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false"/>
</van-popup>

  <van-tabbar v-model="active">
    <van-tabbar-item name="servis" to="/servis" icon="wap-home-o">Servis</van-tabbar-item>   
    <van-tabbar-item name="detay" :to="`/servis/${id*8589}`" icon="home-o">Genel</van-tabbar-item>
    <van-tabbar-item name="islem" :to="`/islem/${id*8589}`" icon="notes-o">İşlem</van-tabbar-item>
    <van-tabbar-item name="stok" :to="`/stok/${id*8589}`" icon="points">Stok</van-tabbar-item> 
    <van-tabbar-item name="matbuu" :to="`/matbuu/${id*8589}`" icon="photo-o">Matbuu</van-tabbar-item>
    <van-tabbar-item name="konum" :to="`/konum/${id*859}`" icon="location-o">Konum</van-tabbar-item>
  </van-tabbar>
  <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
</div>
</template>

<script>
import { Toast } from 'vant';
import { Dialog } from 'vant';
import {router} from '@/router'
export default {
  data() {
    return {
      id:this.$route.params.id/8589,
      error:[],
      active:'islem',
      st:'',
      stid:'',
      snid:'',
      value: '',
      depo:'',
      akod:'000000',
      columns: [],
      ariza:[],
      sn:[],
      mesajilk:'',
      showPicker: false,
      donem : this.$request.donem(),
      ayar:this.$request.ayar(),
      show : false,
      posts:[],
      teknik:'',
     isLoading: false,
     mesaj:'',
     akod:''
    };
  },
  created(){
  this.yetki();
  //this.islemgetir();
  
  },
  methods: {
        yetki(){
          let baslat = false;
          let table ='';
          if (this.ayar.ya=='sid'){
          table = 'servis'
          this.kayitgetir(this.id,table, this.reversedMessage)
          }
          else{
           table = 'kayit'
           this.kayitgetir(this.id,table, this.reversedMessage)
          }
        },
        islemgetir(){ // buraya cihaz id bağlancak 
          this.show = true
          this.$request.get("servis/define/"+this.ayar.firmaid+"/sn")
          .then(res => { 
            console.log(res)
            for (let i = 0; i < res.results.length; i++) {this.columns.push(res.results[i].alias);}
            this.kayitgetir();
        })},

        kayitgetir(sid,table,callback){
          this.show = true
          // this.$request.get("servis/detay/servis/"+this.ayar.ya+"/"+this.ayar.kid+'/'+sid+'/'+table)
          // .then(res => {
            console.log(this.$store.getters.getaktifservis)
            var servis = this.$store.getters.getaktifservis
            this.value =servis.sn
            this.st = servis.st
            this.stid = servis.stid
            this.cid = servis.cid
            this.depo = servis.depo_kod
           // this.snid = res.results[0].snid
          //this.akod = res.servis.ariza_kodu
           this.mesajilk = servis.servis_notu
            callback();
            // })
          },
          reversedMessage () {
            if (this.stid === 2){
       this.$request.get("servis/sngetir/"+this.$store.getters.getaktifservis.anagrup) // ariza
        .then(res=> {
          console.log(res.results)
          //this.sn = res.results
                    res.results.forEach(element => {
                      this.columns.push(element.alias)
                      this.sn.push(
                        {
                          "id" : element.id,
                          "alias":element.alias
                        }
                      )
                    });
                    this.show = false          
        })
      }
      else{

        this.$request.get("servis/sngetir2/"+this.stid+'/'+this.ayar.firmaid) // planlı bakım montaj demontaj
        .then(res => {
          res.results.forEach(element => {
                      this.columns.push(element.alias)
                      this.sn.push(
                        {
                          "id" : element.id,
                          "alias":element.alias
                        }
                      )
                    });
                    this.show = false         })
        .catch(err => this.error.push(err))
        
      }

            // if (this.stid === 2 ){

            //       this.$request.get("servis/arizagetir2/"+this.$store.getters.getaktifservis.cname)
            //       .then(res=> {
            //         console.log(res)
            //         res.results.forEach(element => {
            //           this.columns.push(element.alias)
            //           this.ariza.push(
            //             {
            //               "id" : element.id,
            //               "alias":element.kodu+'#'+element.alias
            //             }
            //           )
            //         });
            //         this.show = false
            //       })

            // }
            // else{
            //   this.$request.get("servis/arizagetir/"+this.stid)
            //   .then(res=> {
            //     res.results.forEach(element => {
            //       this.columns.push(element.alias)
            //       this.ariza.push(
            //         {
            //           "id" : element.id,
            //           "alias":element.alias
            //         }
            //       )
            //     });
            //     this.show = false
            //   })
            // }
         },
        akodgetir(){
          return new Promise ((resolve) =>{
           this.$request.get("servis/cihazgenel/"+this.cid)
            .then(res => {
              resolve(res.cihaz.akod)
            })
          })
        },
    
        onConfirm(value,index) {

          this.value = this.sn[index].alias;
          this.snid = this.sn[index].id

          //this.snid = this.ariza[index].id
          this.showPicker = false;
          // this.ariza = [];
          // this.columns = [];
        },
      tamamla(ipt,deg,txt){
     //alert(this.value)
        if(this.value && this.mesaj){
            Dialog.confirm({
              title: 'Servis '+txt+' Tamamlanacak...',
              message: 'Onaylıyormusnuz ?',
            })
            .then(() => {
              this.show = true
              let islem = {
                sid:this.id,
                not:this.mesajilk+'#'+this.mesaj,
                sd : 4,
                //ariza_kodu:this.value,
                sn:this.snid,
                //depo:this.depo,
                ptarih:new Date(),
                psaat:this.$helper.trsaatyazdir(),
                iptal:ipt,
                degisim:deg,
              }
              this.$request.post("servis/tamamla/",islem)
                .then(res => {
                  this.konum()
                  .then(response => { 
                  
                  let log ={
                  servis_id : this.id,
                  tarih: res.data.ptarih,
                  saat :res.data.psaat,
                  sd:4,
                  kid:this.ayar.kid,
                  islem: 'Servis Tamamlandı',
                  enlem:response.lat,
                  boylam:response.long
                }
                    this.$request.post("servis/servis_log/",log)
                        .then(() => {this.show = false;
                          Toast('Servis Kapatıldı');
                          router.push("/servis")
                        })
                      }) // konum bitişi 

                      })
                    })
                .catch(() => {
                  Toast.loading({
                  message: 'Servis Devam ediyor',
                  forbidClick: true,
                  loadingType: 'spinner',
                  });
                  this.show = false
                });
          }
          else{
            Toast("Girdileri Kontrol Et")
          }
  },
   iptal(){
        if(this.mesaj){
            Dialog.confirm({
              title: 'Servis iptal edilecek...',
              message: 'Onaylıyormusnuz ?',
            })
            .then(() => {
              this.show = true
              let islem = {
              sid:this.id,
              not:this.mesajilk+'&'+this.mesaj,
              sd : 4,
              // ariza_kodu:'iptal',
              // depo:this.depo,
              ptarih:new Date(),
              psaat:new Date(Date.now()),
              iptal:1,
              sn:this.snid,

              }
              this.$request.post("servis/iptal/",islem)
                .then(res => {
                  this.konum()
                  .then(response=> {
                  
                  let log ={
                  servis_id : this.id,
                  tarih: res.data.ptarih,
                  saat :res.data.psaat,
                  sd:4,
                  kid:this.ayar.kid,
                  islem: 'Servis iptal edildi',
                  enlem:response.lat,
                  boylam:response.long
                }
                    this.$request.post("servis/servis_log/",log)
                        .then(() => {this.show = false;
                          Toast('Servis iptal edildi');
                          router.push("/servis")
                        })
                  })// konum bitişi  

                      })
                    })
                .catch(() => {
                Toast.loading({
                message: 'Servis Devam ediyor',
                forbidClick: true,
                loadingType: 'spinner',
                });
                this.show = false
          });
          }
          else{
            Toast("Servis İptal nedeni ?")
          }
  },
      konum(){
      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
              resolve({
                  long:position.coords.longitude,
                  lat:position.coords.latitude
              })
            },
            // işlemleri kitlememek için reject göndermedik
            (error) => {
              resolve({
                  long:0,
                  lat:0
              })              
              //alert(error.message);
            }, {
                    enableHighAccuracy: true
                    , timeout: 5000
                }
            );
        } 
        // işlemleri kitlememek için reject göndermedik
        else { 
              resolve({
                  long:0,
                  lat:0
              })            
          //alert("Geolocation is not supported by this browser.");
             }
      })
    },         
  }
};
</script>


// WEBPACK FOOTER //
// src/components/servis/tamamla.vue